import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'SearchByCategory'
})

export class SearchFilesByCategory implements PipeTransform {
    transform(value: any, input: string) {
        if (input) {
            return value.filter(function (el: any) {
                const FileCategory = el.fileType.trim().toUpperCase() == input.trim().toUpperCase() ? true : false;

                return (FileCategory);
            })
        }
        return value;
    }
}